module.exports = __webpack_public_path__ + "img/violet_070.45ef7675.png";